import * as React from 'react';
import { useAutocomplete } from '@mui/base/useAutocomplete';

export default function AutoComplete({
  selectValue,
  options,
  handleSubmitSelection,
  layerId,
}) {
  const handleSelectChange = (newValue) => {
    let value;
    if (newValue){
      value = typeof newValue === 'string' ? newValue : newValue.value;
    }
    else {
      value = '';
    }
    handleSubmitSelection(value);
  };

  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    focused,
    inputValue,
  } = useAutocomplete({
    id: 'use-autocomplete-demo'+layerId,
    options: options,
    value: selectValue,
    onChange: (event, newValue) => handleSelectChange(newValue),
    freeSolo: true,
    openOnFocus: true,
    selectOnFocus: false,
  });

  return (
    <div style={{ marginBottom: 16 }}>
      {inputValue.length <= 0 && (
        <label className="Select-placeholder" {...getInputLabelProps()}>Search for Graphics</label>
      )}
      <div {...getRootProps()}>
        <input className="Select-control" {...getInputProps()} />
      </div>
      {groupedOptions.length > 0 && (
        <ul className="Select-menu-outer" {...getListboxProps()}>
          {groupedOptions.map((option, index) => (
            <li className="Select-result" {...getOptionProps({ option, index })}>{option.label}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
